import { loadRuntimeConfig } from './config/runtimeConfig';
import { startApp } from './utils/startApp.js';

// Two ordering constraints meet here, and both matter.
//
// 1. Runtime config must be published to window.__CONFIG__ BEFORE the app's module graph is
//    evaluated, because modules read config at import time (src/supabase/supabase.js takes its
//    URL and anon key there, src/config/flags.js resolves feature flags from it). renderApp.jsx
//    imports App.jsx STATICALLY, so importing renderApp dynamically — and only after the await
//    below — is what keeps that guarantee. Static-importing renderApp here would evaluate the
//    whole app before config.json had been fetched.
//
// 2. startApp wraps the load so a failure paints a plain-DOM error panel instead of a white
//    screen. Config fetch failures are inside the try for exactly that reason: an environment
//    whose /config.json is missing or malformed now says so rather than rendering an app wired
//    to undefined credentials.
startApp(async () => {
  await loadRuntimeConfig();
  await import('./renderApp.jsx');
});
